export default "__VITE_ASSET__CvbVu$xJ__"